import { myReduxProxy } from 'v5/api/_common/reduxProxy.connected';
import { myShortlistApi } from '../../../api/shortlist/shortlist.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myTagsService } from '../TagsService/TagsService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { createShortlistMutationService } from './ShortlistMutationService.impl';

export const myShortlistMutationService = createShortlistMutationService({
  api: myShortlistApi,
  reduxProxy: myReduxProxy,
  services: {
    errorService: myErrorService,
    messageService: myMessageService,
    tagsService: myTagsService
  }
});
